import { render, staticRenderFns } from "./Einstellungen.vue?vue&type=template&id=3ad6d773"
import script from "./Einstellungen.vue?vue&type=script&lang=js"
export * from "./Einstellungen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ad6d773')) {
      api.createRecord('3ad6d773', component.options)
    } else {
      api.reload('3ad6d773', component.options)
    }
    module.hot.accept("./Einstellungen.vue?vue&type=template&id=3ad6d773", function () {
      api.rerender('3ad6d773', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Einstellungen.vue"
export default component.exports